import { store } from '../store';
import { RemoveUser } from '../slices/user';
import { ClearAssessment } from '../slices/assessment';
import { resetNotifications } from '../slices/notification';

// Create a custom event that components can listen to for cleanup
export const LOGOUT_EVENT = 'app_logout';

export const clearAllState = () => {
  const { dispatch } = store;

  // Dispatch a custom event that components can listen to for cleanup
  window.dispatchEvent(new Event(LOGOUT_EVENT));

  // Clear user data
  dispatch(RemoveUser());

  // Clear assessment data
  dispatch(ClearAssessment());

  // Clear in-app notifications
  dispatch(resetNotifications());
};
